<template>
  <div class="checkin__last-call d-flex align-items-center justify-content-between w-100" v-if="!expired">
    <div>
      <template>
        <Icon name="alertTriangle" width="20" class="mr-2"/>
        {{ $t('pages.checkin_info_media.list_message') }}
      </template>
    </div>
    <div>
      <b-button size="sm" class="" variant="outline">
        {{ $t('pages.checkin_info_media.list_cta') }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "InfoSdHdAvailableList",
  props: {
    hdAvailableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    expired() {
      return new Date(this.hdAvailableTo) < new Date()
    },
  },
}
</script>


<style scoped>

</style>